var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "#EEF5FC",
    stroke: "#036",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15H16.99c-1.11 0-1.98.89-1.98 2L15 31c0 1.1.88 2 1.99 2H31c1.1 0 2-.9 2-2V17a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3h-4.01V17H31v10z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjMiIGZpbGw9IiNFRUY1RkMiIHN0cm9rZT0iIzAwMzM2NiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMSAxNUgxNi45OUMxNS44OCAxNSAxNS4wMSAxNS44OSAxNS4wMSAxN0wxNSAzMUMxNSAzMi4xIDE1Ljg4IDMzIDE2Ljk5IDMzSDMxQzMyLjEgMzMgMzMgMzIuMSAzMyAzMVYxN0MzMyAxNS44OSAzMi4xIDE1IDMxIDE1Wk0zMSAyN0gyN0MyNyAyOC42NiAyNS42NSAzMCAyNCAzMEMyMi4zNSAzMCAyMSAyOC42NiAyMSAyN0gxNi45OVYxN0gzMVYyN1oiIGZpbGw9IiMwMDMzNjYiLz4KPC9zdmc+Cg==";
export { SvgConfirmationIcon as ReactComponent };